/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestionOption } from './QuestionOption';
import {
    QuestionOptionFromJSON,
    QuestionOptionFromJSONTyped,
    QuestionOptionToJSON,
    QuestionOptionToJSONTyped,
} from './QuestionOption';
import type { QuestionFieldCondition } from './QuestionFieldCondition';
import {
    QuestionFieldConditionFromJSON,
    QuestionFieldConditionFromJSONTyped,
    QuestionFieldConditionToJSON,
    QuestionFieldConditionToJSONTyped,
} from './QuestionFieldCondition';

/**
 * 
 * @export
 * @interface Question
 */
export interface Question {
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    group_options_by_category?: boolean;
    /**
     * 
     */
    options?: Array<QuestionOption>;
    /**
     * 
     */
    internal_options?: Array<QuestionOption>;
    /**
     * 
     */
    internal_option_to_platform_option_map?: { [key: string]: any; };
    /**
     * 
     */
    required?: boolean;
    /**
     * 
     */
    show_if?: QuestionFieldCondition;
}

/**
 * Check if a given object implements the Question interface.
 */
export function instanceOfQuestion(value: object): value is Question {
    return true;
}

export function QuestionFromJSON(json: any): Question {
    return QuestionFromJSONTyped(json, false);
}

export function QuestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Question {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'group_options_by_category': json['group_options_by_category'] == null ? undefined : json['group_options_by_category'],
        'options': json['options'] == null ? undefined : ((json['options'] as Array<any>).map(QuestionOptionFromJSON)),
        'internal_options': json['internal_options'] == null ? undefined : ((json['internal_options'] as Array<any>).map(QuestionOptionFromJSON)),
        'internal_option_to_platform_option_map': json['internal_option_to_platform_option_map'] == null ? undefined : json['internal_option_to_platform_option_map'],
        'required': json['required'] == null ? undefined : json['required'],
        'show_if': json['show_if'] == null ? undefined : QuestionFieldConditionFromJSON(json['show_if']),
    };
}

export function QuestionToJSON(json: any): Question {
    return QuestionToJSONTyped(json, false);
}

export function QuestionToJSONTyped(value?: Question | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'group_options_by_category': value['group_options_by_category'],
        'options': value['options'] == null ? undefined : ((value['options'] as Array<any>).map(QuestionOptionToJSON)),
        'internal_options': value['internal_options'] == null ? undefined : ((value['internal_options'] as Array<any>).map(QuestionOptionToJSON)),
        'internal_option_to_platform_option_map': value['internal_option_to_platform_option_map'],
        'required': value['required'],
        'show_if': QuestionFieldConditionToJSON(value['show_if']),
    };
}

